/** Display formatting for proportions and measures (results are 0-1). */

export function fmtPct(x: number, digits = 1): string {
  if (!Number.isFinite(x)) return '—';
  return `${(x * 100).toFixed(digits)}%`;
}

export function fmtCv(cv: number | undefined): string {
  if (cv === undefined || !Number.isFinite(cv)) return '—';
  return `${(cv * 100).toFixed(cv >= 0.095 ? 0 : 1)}%`;
}

export function fmtNumber(x: number, digits = 2): string {
  if (!Number.isFinite(x)) return '—';
  return x.toFixed(digits);
}

export function fmtInt(x: number): string {
  return Math.round(x).toLocaleString('en-US');
}
